// @mui
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------
type ColoredIconProps = {
  color: 'info' | 'success' | 'warning' | 'error';
};

export const ColoredIcon = styled('span')<ColoredIconProps>(({ color, theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette[color]?.main || theme.palette.text.primary,
}));
